//Importaciones
import React, { useContext, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ActionButton, Checkbox, css, Icon, IconButton, mergeStyles, mergeStyleSets, Slider, Toggle, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import { isNullUndefined, showMessage } from '../../../../../../common/Helpers';
import MessageBoxInfoComplex from '../../../../../Common/Message/MessageBoxInfoComplex';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_BoardFilters } from '../../../../../../common/ObjectStructures/sKPI';
import { useDispatch, useSelector } from 'react-redux';
import MainAppContext from '../../../../../../MainAppContext';
import { action_setCompareContracts_ChartData, action_setCompareContracts_ChartData_Structure, action_setCompareContracts_Contratos, action_setCompareContracts_FireGetData, action_setCompareContracts_SegmentList, action_setCompareContracts_SegmentSelected } from '../../../../../../reducers/actions/KPI/compareContractsActions';
import { useSearch } from '../../../../../../hooks/component/useOfContractCompare';
import './style.css'
import { action_setPortfolio_Report_ElementIds } from '../../../../../../reducers/actions/SITE/portfolioActions';
import { __onGoToBoardKpiOperational } from '../../../../../../common/SystemRedirections';

function ELEMENT_CONTRACT_LIST_TO_COMPARE(props) {
    //Helpers
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);
	const classNames = mergeStyleSets({
		overflow: {
		  overflow: 'hidden',
		  textOverflow: 'ellipsis',
		},
	});
    const { 
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_UseFake = false,
		inputParam_BoardId = null,
    } = props;

    const { 
		_pilarSeleccionado: pilarSeleccionado,
		_contratosParaGrafico: selectedContracts,
		_contratosFiltrados: contratosFiltrados,
		_contratosBase: contratosBase,
		_segmentSelected: segmentSelected,
	} = useSelector((state) => state.compareContractsScope);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

	const sliderValueFormat = (value) => `${value}%`;
	const sliderAriaValueText = (value) => `${value} percent`;
	const [lowerScopeValue, setLowerScopeValue] = useState(0);
	const [upperScopeValue, setUpperScopeValue] = useState(0);

	const [defaultSelectedFiltersBinded, setDefaultSelectedFiltersBinded] = useState(true);
	const [selectAllVariables, setSelectAllVariables] = useState(false);

    const onChangeContract = (ev, isChecked, contract) => {
        let _aux_selectedContract = [...selectedContracts]
        dispatch(action_setCompareContracts_FireGetData(true))
		
        if (isChecked) {
			_aux_selectedContract.push(contract)
			dispatch(action_setCompareContracts_Contratos(_aux_selectedContract))
			dispatch(action_setPortfolio_Report_ElementIds(_aux_selectedContract.map(x => x.elementId)));
		}
        else {
            _aux_selectedContract = _aux_selectedContract.filter(x => x.id !== contract.id);
            dispatch(action_setCompareContracts_Contratos(_aux_selectedContract))
			dispatch(action_setPortfolio_Report_ElementIds(_aux_selectedContract.map(x => x.elementId)));
        }

		setDefaultSelectedFiltersBinded(false);
		
		dispatch(action_setCompareContracts_ChartData_Structure(null))//ojo
		dispatch(action_setCompareContracts_SegmentList(null))
		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: null, cardSegment: null, propertySegment: null}))
    }

	const onSearch = () => {
		let _aux_selectedContract = []
		dispatch(action_setCompareContracts_FireGetData(true))

		if (contratosFiltrados && contratosFiltrados.length > 0) {
			contratosFiltrados.forEach(element => {
				if (!isNullUndefined(element.goalKpiRegister) && (element.goalKpiRegister >= lowerScopeValue && element.goalKpiRegister <= upperScopeValue)) {
					_aux_selectedContract.push(element)
				}
			});
		}
		else {
			contratosBase.forEach(element => {
				if (!isNullUndefined(element.goalKpiRegister) && (element.goalKpiRegister >= lowerScopeValue && element.goalKpiRegister <= upperScopeValue)) {
					_aux_selectedContract.push(element)
				}
			});
		}

		dispatch(action_setCompareContracts_Contratos(_aux_selectedContract));
		dispatch(action_setPortfolio_Report_ElementIds(_aux_selectedContract.map(x => x.elementId)));
		dispatch(action_setCompareContracts_ChartData_Structure(null))//ojo
		dispatch(action_setCompareContracts_SegmentList(null))
		setDefaultSelectedFiltersBinded(false);

		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: null, cardSegment: null, propertySegment: null}))
	}

	const onRangeChange = (value, range) => {
		if (range) {
			setLowerScopeValue(range[0]);
			setUpperScopeValue(range[1]);
		} else {
			setUpper(value);
		}
	};

	const onChangeSelectAll = (ev, checked) => {     
		if (checked) {
			dispatch(action_setCompareContracts_Contratos(!isNullUndefined(contratosFiltrados) ? contratosFiltrados : contratosBase))
			dispatch(action_setPortfolio_Report_ElementIds(!isNullUndefined(contratosFiltrados) ? contratosFiltrados.map(x => x.elementId) : contratosBase.map(x => x.elementId)));
		}
		else {
			dispatch(action_setCompareContracts_Contratos([]))
			dispatch(action_setPortfolio_Report_ElementIds([]))
		}
		
		dispatch(action_setCompareContracts_FireGetData(true))
		dispatch(action_setCompareContracts_ChartData(null))//ojo
		dispatch(action_setCompareContracts_ChartData_Structure(null))//ojo
		dispatch(action_setCompareContracts_SegmentList(null))
		setSelectAllVariables(checked);
		setDefaultSelectedFiltersBinded(false);
		setLowerScopeValue(0);
		setUpperScopeValue(0);

		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: null, cardSegment: null, propertySegment: null}))
	};

	const textoRecortadoClase = mergeStyles({
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		display: 'block',
		width: '100%',
	});

	const hostStyles = { 
		root: { 
			display: 'block', 
			maxWidth: '100%'
		} 
	};

    const renderContent = () => {
		return  <Row className='px-3'>
					<div style={{maxHeight: "200px"}}>
						{
							(!isNullUndefined(contratosFiltrados) ? contratosFiltrados : (inputParam_ComponentContent && contratosBase)).map(contract => (
								<Row key={contract.id} className='border-bottom'>
									{
										!isNullUndefined(contract.goalKpiRegister) &&
										<Col className="p-0 m-0">
											<Row className="p-0 m-0 d-flex">
												<Col className='col-auto me-auto p-0 m-0' xl={3}>
													<IconButton title={t('data-lang-lbl-kpi')} styles={{root: {color: "#115e8c"}}} iconProps={{iconName: "Financial"}} onClick={() => __onGoToBoardKpiOperational(contract.elementId, 4)} />
												</Col>
												<Col xl={9} className={`col-auto text-center me-auto my-auto ${" variable-value-color-na2"}`} style={{color: 'white'}}>
													<TooltipHost content={t('data-lang-msg-percentagekpiselectedperiod')} calloutProps={{ gapSpace: 0 }} >
														<div className='w-100'><b>{`${ !isNullUndefined(contract.goalKpiRegister) ? Math.round(Math.trunc(contract.goalKpiRegister * 100) / 100)/*.toFixed(0)*/ : t('no-data') }%`}</b></div>
													</TooltipHost>
												</Col>
											</Row>
										</Col>
									}
									{
										isNullUndefined(contract.goalKpiRegister) &&
										<Col className="p-0 m-0">
											<Row className="p-0 m-0 d-flex">
												<Col className='col-auto me-auto p-0 m-0' xl={3}>
													<IconButton title={t('data-lang-lbl-kpi')} styles={{root: {color: "#115e8c"}}} iconProps={{iconName: "Financial"}} onClick={() => __onGoToBoardKpiOperational(contract.elementId, 4)} />
												</Col>
												<Col xl={9} className={`col-auto text-center me-auto my-auto ${" variable-value-color-na2"}`} style={{color: 'white'}}>
													<TooltipHost content={t('data-lang-msg-percentagekpiselectedperiod')} calloutProps={{ gapSpace: 0 }} >
														<div className='w-100'><b>{`${ t('no-data') }`}</b></div>
													</TooltipHost>
												</Col>
											</Row>
										</Col>
									}
									<Col xl={9} className='p-0 m-0 ps-1'>
										<div className='d-flex'>
											<div className='pe-0 m-0' style={{width: "25px"}}>
												<Checkbox
													className='my-2'
													checked={!isNullUndefined(selectedContracts) && !isNullUndefined(selectedContracts.find(x => x.id === contract.id))}
													onChange={(ev, checked) => onChangeContract(ev, checked, contract)}
												/>
											</div>
											<div className='text-start my-auto p-0 m-0'>
												<TooltipHost content={`${contract.contractCode} - ${contract.supplierName}`} id="tooltip-recorte" styles={hostStyles}>
													<span className={textoRecortadoClase} aria-describedby="tooltip-recorte">
														{`${contract.contractCode} - ${contract.supplierName}`}
													</span>
												</TooltipHost>
											</div>
										</div>
									</Col>
								</Row>
							))
						}
					</div>
				</Row>
    }

	useSearch(defaultSelectedFiltersBinded, setDefaultSelectedFiltersBinded, contextSite, selectedContracts, inputParam_BoardId, pilarSeleccionado, segmentSelected)

    //Render de componente.
    return (
		<>
			{
			!inputParam_UseFake &&
			<Card className='h-100'>
				{
				!inputParam_HideHeader &&
				<>
					<Card.Header className="card-header-compact">
						<Card.Title className="d-flex justify-content-between">
						<b>{(!inputParam_UseFake && inputParam_ComponentContent !== null) ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-contract_list_to_compare')) : t('data-lang-boxname-contract_list_to_compare')}</b>
						<div className='toolbar d-flex'>
							<Toggle
								checked={ selectAllVariables === true || (!isNullUndefined(selectedContracts) && !isNullUndefined(contratosFiltrados) ? selectedContracts.length === contratosFiltrados.length : selectAllVariables) }
								onChange={ onChangeSelectAll }
								role="checkbox"
								onText={t('data-lang-lbl-all')}
								offText={t('data-lang-lbl-nothing')}
								styles={ {root:{paddingTop: "6px", float: "right", display: "flex"}, label: {marginRight : "25px", padding: "0px, 10px"}} }
							/>
						</div>
						</Card.Title>
					</Card.Header>
					{
						messageConfig.showMessage &&
						<Card.Footer>
							<MessageBoxInfoComplex
								inputParam_Message={ messageConfig.message }
								inputParam_Display={ messageConfig.showMessage }
								inputParam_MessageType={ messageConfig.messageType }
								inputParam_SetterMessage={ setMessageConfig }
								inputParam_ShowClose={true}
								inputParam_TranslateText={true}
							/>
						</Card.Footer>
					}

						<Card.Footer className="d-flex justify-content-between border-bottom">
							<div className='toolbar'>
								<Row>
									<Col>
										<Slider
											label={t('data-lang-msg-filterslidercontractportfolio')}
											max={100}
											ariaValueText={sliderAriaValueText}
											valueFormat={sliderValueFormat}
											ranged
											showValue
											styles={{root: {width: "100%"}, titleLabel: {fontSize: '12px'}}}
											value={upperScopeValue}
											lowerValue={lowerScopeValue}
											onChange={onRangeChange}
										/>
									</Col>
									<Col className='col-auto me-auto'>
										<ActionButton iconProps={{ iconName: 'Filter' }} onClick={onSearch} allowDisabledFocus />
									</Col>
								</Row>
							</div>
						</Card.Footer>

				</>
				}
				<Card.Footer>
					<Row className='border-bottom'>
						<Col xl={3} className='text-center'>
							<TooltipHost content={t('data-lang-msg-ingreso_kpi')} calloutProps={{ gapSpace: 0 }} >
								<Icon iconName='WindowEdit' />
							</TooltipHost>
						</Col>
						<Col xl={9}>
						{t('data-lang-lbl-contracts')}
						</Col>
					</Row>
				</Card.Footer>
				<Card.Body className='p-0 m-0' style={{overflowY: "scroll", overflowX: "hidden"}}>
				{ renderContent() }
				</Card.Body>
			</Card>
			}
			{ inputParam_UseFake && renderContent() }
		</>
    );
}

ELEMENT_CONTRACT_LIST_TO_COMPARE.propTypes = {
	inputParam_HideHeader: PropTypes.bool.isRequired,
	inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default ELEMENT_CONTRACT_LIST_TO_COMPARE;